export const includeManePlus = (transcripts) =>
  transcripts.some(
    (t) => typeof t.mane_plus !== "undefined" && t.mane_plus !== null
  );
export const includeManeSelect = (transcripts) =>
  transcripts.some(
    (t) => typeof t.mane_select !== "undefined" && t.mane_select !== null
  );
export const includeAppris = (transcripts) =>
  transcripts.some(
    (t) => typeof t.ensembl_appris !== "undefined" && t.ensembl_appris !== null
  );
export const includeUniprotId = (transcripts) =>
  transcripts.some(
    (t) => typeof t.uniprot_id !== "undefined" && t.uniprot_id !== null
  );
export const includeTSL = (transcripts) => {
  return transcripts.some(
    (t) =>
      typeof t.ensembl_support_level !== "undefined" &&
      t.ensembl_support_level !== null
  );
};

// Check if any transcript has either hgvs_p1 or hgvs_p3 set
export const isProteinLevelAvailable = (transcripts) => {
  return transcripts.some((item) => item.hgvs_p1 || item.hgvs_p3);
};

export const getManeTranscriptForACMG = (
  transcriptName,
  refseqTranscriptsOptions,
  ensemblTranscriptsOptions
) => {
  // If transcriptName is missing or both transcript options arrays are empty, return an empty string
  if (
    !transcriptName ||
    (!refseqTranscriptsOptions?.length && !ensemblTranscriptsOptions?.length)
  )
    return "";

  // Search if transcript is present in refseq transcripts
  const refSeqMatch = refseqTranscriptsOptions?.filter(
    (item) => item.name === transcriptName
  );

  // Search if transcript is present in ensembl transcripts
  const ensemblMatch = ensemblTranscriptsOptions?.filter(
    (item) => item.name === transcriptName
  );

  if (refSeqMatch?.length || ensemblMatch?.length) {
    // Try to get the mane transcripts if they exist
    const { mane_plus: reseqManePlus, mane_select: refseqManeSelect } =
      refSeqMatch?.[0] || {};
    const { mane_plus: ensemblManePlus, mane_select: ensemblManeSelect } =
      ensemblMatch?.[0] || {};

    // Check if any available results exist and render them
    if (
      reseqManePlus ||
      refseqManeSelect ||
      ensemblManePlus ||
      ensemblManeSelect
    ) {
      if (reseqManePlus || ensemblManePlus) return "MANE Plus Clinical, ";
      return "MANE Select, ";
    }
    return "";
  }

  return "";
};
export const showGeneColumn = (variantResult) => {
  // Show gene column if more than one gene
  return variantResult?.genes;
};
